import { render, staticRenderFns } from "./RelatedContent.vue?vue&type=template&id=8d7257d2&scoped=true"
import script from "./RelatedContent.vue?vue&type=script&lang=js"
export * from "./RelatedContent.vue?vue&type=script&lang=js"
import style0 from "./RelatedContent.vue?vue&type=style&index=0&id=8d7257d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7257d2",
  null
  
)

export default component.exports